var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.708 19.642H7.205a2.22 2.22 0 0 1-2.216-2.217V6.575a2.22 2.22 0 0 1 2.216-2.217h4.576c.275 0 .494-.22.494-.494a.49.49 0 0 0-.494-.495H7.205A3.21 3.21 0 0 0 4 6.575v10.85c0 1.77 1.44 3.206 3.205 3.206h4.503a.495.495 0 0 0 0-.99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.855 11.652-3.143-3.143a.493.493 0 0 0-.7 0 .493.493 0 0 0 0 .7l2.3 2.3H8.28a.493.493 0 0 0-.495.495c0 .274.22.494.495.494h10.034l-2.3 2.3a.498.498 0 0 0 .348.846.48.48 0 0 0 .347-.146l3.143-3.143a.494.494 0 0 0 .004-.703"
  })));
};
export default SvgLogout;